import { useEffect, useState } from 'react'
import { Locale } from 'date-fns'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { createCustomDatePickerLocale } from 'utils/createCustomDatePickerLocale'
import { loadDatePickerLocale } from 'components/TasksV2/TaskCreation/Steps/TimeFrameSelection/loadDatePickerLocale'
import { isRtlSelector } from 'redux/selectors/general'

export const useDatePickerLocale = (useCustomTranslations: boolean = true): Locale | undefined => {
  const locale = useSelector((state: RootState) => state.general.locale)
  const [datePickerLocale, setDatePickerLocale] = useState<Locale>()
  const translations = useSelector((state: RootState) => state.config.translations)
  const isRtl = useSelector(isRtlSelector)

  useEffect(() => {
    const loadLocale = async () => {
      if (useCustomTranslations) {
        const customLocale = createCustomDatePickerLocale({
          locale,
          translations,
          isRtl: isRtl,
        })
        setDatePickerLocale(customLocale)
      } else {
        const loadedLocale = await loadDatePickerLocale(locale)
        setDatePickerLocale(loadedLocale)
      }
    }

    loadLocale()
  }, [locale, useCustomTranslations, translations, isRtl])

  return datePickerLocale
}
